import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { GameCategoryViewModel } from "@playcharge/common/models/backend/offers/game-category-view-model";
import { Observable } from "rxjs";
import { ApiRoutes } from "../models/constants/api-routes";
import { ApiUtils } from "../utils/api-utils";

@Injectable({
    providedIn: "root",
})
export class ApiGameCategoriesService {
    private _httpClient = inject(HttpClient);

    public getAll(): Observable<GameCategoryViewModel[]> {
        return this._httpClient.get<GameCategoryViewModel[]>(
            ApiUtils.buildUserUrl(ApiRoutes.gameCategories.root),
        );
    }
}
